import CloseIcon from 'admin/common/icons/CloseIcon';
import LinkAttachmentIcon from 'admin/common/icons/LinkAttachmentIcon';
import RightArrow from 'admin/common/icons/right-arrow';
import SearchIcon from 'admin/common/icons/SearchIcon';
import FilterIconMain from 'admin/common/icons/sidebar/FilterIconMain';
import TableLoader from 'admin/common/TableLoader';
import { Pagination } from 'components/common/Pagination';
import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import Select from "react-select";
import ZoneFilter from './ZoneFilter';
import Apiauth from '../../API/Apiauth.js';
import aibirdeyeIcon from '../../assets/images/aibirdeye.svg';
import AddInventoryTableHead from './AddInventoryTableHead';
import { sortInventoryRows } from './zoneTableSortUtils';
import './AddInventory.scss';

const ADD_INVENTORY_IMAGE_PLACEHOLDER =
  'https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png';

const getProductImageSrc = (imageUrl) =>
  imageUrl && String(imageUrl).trim()
    ? imageUrl
    : ADD_INVENTORY_IMAGE_PLACEHOLDER;

const handleProductImageError = (event) => {
  const image = event.currentTarget;
  if (image.src.includes('placeholder-blank.png')) {
    return;
  }
  image.onerror = null;
  image.src = ADD_INVENTORY_IMAGE_PLACEHOLDER;
};

const getCollectionNameFromRow = (row) =>
  row?.collection_name || row?.Collection_name || row?.collection || '';

const EMPTY_FILTER_ITEM_DATA = {
  item: [],
  collection: [],
  metal: [],
  stone: [],
  size: [],
  location: [],
};

export default function AddInventory({
  selectedLocation,
  issueId,
  handleBackToParent,
  setPoProductId,
  setPoProductCollectionMap,
}) {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [limit, setLimit] = useState(100);
  const [total, setTotal] = useState(100);
  const [filtername, setFiltername] = useState("");
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");
  const [datalodaer, setDatsLodaer] = useState(true);
  const [openSearch, setOpenSearch] = useState(false);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [state, setstate] = useState({ totalPages: 20, currentPage: 1, });
  const [inventoryData, setInventoryData] = useState([])
  const [searchTrigger, setSearchTrigger] = useState(0)
  const [filterItemData, setFilterItemData] = useState(EMPTY_FILTER_ITEM_DATA)
  const [appliedFilterItemData, setAppliedFilterItemData] = useState(
    EMPTY_FILTER_ITEM_DATA
  )
  const [filterOptionsData, setFilterOptionsData] = useState({})
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [selecteditem, setSelecteditem] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, dir: 'asc' });

  const { totalPages, currentPage } = state;
  const sortedInventoryData = useMemo(
    () => sortInventoryRows(inventoryData, sortConfig),
    [inventoryData, sortConfig]
  );
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]

  const getlimit = (limit) => {
    setLimit(limit);
  };

  const getInventoryList = useCallback(
    async (page = currentPage, firstLimit = limit, filters = appliedFilterItemData) => {

      setDatsLodaer(true);
      try {

        const postdata = {
          search: appliedSearchTerm,
          item: filters?.item ? filters.item : [],
          collection: filters?.collection ? filters.collection : [],
          metal: filters?.metal ? filters.metal : [],
          size: filters?.size ? filters.size : [],
          stone: filters?.stone ? filters.stone : [],
          location: [selectedLocation],
          limit: firstLimit,
          skip: (page - 1) * firstLimit,
        };
        if (issueId) {
          postdata.issue_id = issueId;
        }
        if (sortConfig.key) {
          postdata.sort_by = sortConfig.key;
          postdata.sort_order = sortConfig.dir;
        }
        let apiRes = await Apiauth(postdata, `zone/get-inventory-list`);

        if (apiRes.code === 200) {
          setInventoryData(apiRes.data);
          setTotal(apiRes.count);
          setSelectAllStatus(false);

          setstate((prevPages) => ({
            ...prevPages,

            totalPages: Math.ceil(apiRes.count / postdata.limit),

          }));
        }
      } catch (err) {
        console.error(err, "API Error");
      } finally {
        setDatsLodaer(false);
      }
    },
    [currentPage, limit, appliedSearchTerm, selectedLocation, issueId, sortConfig, appliedFilterItemData]
  );

  useEffect(() => {
    getInventoryList(currentPage, limit, appliedFilterItemData);
  }, [currentPage, limit, searchTrigger, getInventoryList, appliedFilterItemData, sortConfig]);

  useEffect(() => {
    const getFilterOptions = async () => {
      try {
        const apiRes = await Apiauth({}, 'Inventory/my/filter');
        if (apiRes.code === 200) {
          setFilterOptionsData(apiRes.data || {});
        }
      } catch (err) {
        console.error(err, 'API Error');
      }
    };

    getFilterOptions();
  }, []);

  const handleSort = (key) => {
    setDatsLodaer(true);
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      }
      return { key, dir: 'asc' };
    });
    setstate((prev) => ({ ...prev, currentPage: 1 }));
  };



  const handlePaginations = (current) => {
    setDatsLodaer(true);
    setstate({ ...state, currentPage: current });
  };

  const handleSearchKeyDown = (event) => {
    if (event.key !== 'Enter') return;

    event.preventDefault();
    setDatsLodaer(true);
    setAppliedSearchTerm(filtername.trim());
    setstate((prev) => ({ ...prev, currentPage: 1 }));
    setSearchTrigger((prev) => prev + 1);
  };

  const handleCloseSearch = () => {
    setOpenSearch(false);
    setFiltername('');
    setAppliedSearchTerm('');
    setDatsLodaer(true);
    setstate((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleApplyFilters = () => {
    setDatsLodaer(true);
    setAppliedFilterItemData({ ...filterItemData });
    setstate((prev) => ({ ...prev, currentPage: 1 }));
    setToggleFilter(false);
  };

  const handleClearFilters = (clearedFilters = EMPTY_FILTER_ITEM_DATA) => {
    setDatsLodaer(true);
    setFilterItemData(clearedFilters);
    setAppliedFilterItemData(clearedFilters);
    setstate((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      const mainselected = [...selecteditem, event.target.value];

      setSelecteditem(mainselected);
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value;
      });
      setSelecteditem(result);
    }


  }
  let selectAllStatus_arr = [];

  useEffect(() => {
    var allCheckbox = document.querySelectorAll('.zone_addinventory');
    if (selectAllStatus === true) {
      allCheckbox.forEach(function (checkBox_selectAble) {
        checkBox_selectAble.checked = true;
        if (checkBox_selectAble.value !== "on") {
          selectAllStatus_arr.push(checkBox_selectAble.value);
        }
      });
      let arrya = [];
      for (let i = 0; i < allCheckbox.length; i++) {
        if (allCheckbox[i].checked) {
          let product_id = allCheckbox[i].getAttribute('data-id');
          if (product_id !== "on") {
            arrya.push(product_id);
          }
        }
      }
      setSelecteditem(arrya);
    } else {
      allCheckbox.forEach(function (checkBox_selectAble) {
        checkBox_selectAble.checked = false;
      });
      setSelecteditem([]);
    }
    setSelecteditem(selectAllStatus_arr);

    // eslint-disable-next-line
  }, [selectAllStatus]);

  const onConfirm = () => {
    const collectionByProductId = {};
    selecteditem.forEach((productId) => {
      const row = inventoryData.find(
        (item) => String(item?.id) === String(productId)
      );
      const collectionName = getCollectionNameFromRow(row);
      if (collectionName) {
        collectionByProductId[productId] = collectionName;
      }
    });
    setPoProductId(selecteditem);
    setPoProductCollectionMap?.(collectionByProductId);
    handleBackToParent();
  }

  return (
    <>
      <div className="main-body zone_module">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-between">
              <h1 className="main-body-heading">
                <span>
                  <Link onClick={handleBackToParent} className='text-decoration-none'> {t('Create Issue')}</Link> <span className='ms-2'><RightArrow /></span>
                </span>
                {t("Add Inventory")}
              </h1>
              <Link
                onClick={onConfirm}
                className="confirmbtn"
              >
                {t("Confirm")}
              </Link>
            </div>
            <div className='zone_module-inner'>
              <div className="main-body-top-status-bar">
                <Select
                  className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => { setDatsLodaer(true); setLimit(e.value); getlimit(e.value) }}
                  isSearchable={false}
                />

                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className={`main-body-top-status-bar-multi-date-picker-iconholder ${openSearch ? 'active' : ''}`}><span onClick={() => setOpenSearch(true)}><SearchIcon color="#A4A4A4" /></span><div className={`main-body-top-status-bar-multi-date-picker-iconholder-searchbar ${openSearch ? 'active' : ""}`}>
                    <input
                      type="text"
                      className='main-body-top-status-bar-filter-input'
                      value={filtername}
                      placeholder={t("Search")}
                      onChange={(e) => setFiltername(e.target.value)}
                      onKeyDown={handleSearchKeyDown}
                    />
                    <span onClick={handleCloseSearch}><CloseIcon /></span> </div></div>
                  <span onClick={() => setToggleFilter(!toggleFilter)} className='main-body-top-status-bar-multi-date-picker-iconholder'><FilterIconMain width="24px" height="24px" /></span>


                </div>
              </div>
              <div className='zone_module-inner-table'>
                <div className="zone-add-inventory__table-wrap main-body-main-table-wrap position-relative">
                  <table
                    id="my_inventory"
                    className="stripe row-border order-column common-table table-striped main-table w-100"
                  >
                    <AddInventoryTableHead
                      sortConfig={sortConfig}
                      onSort={handleSort}
                      selectAllStatus={selectAllStatus}
                      setSelectAllStatus={setSelectAllStatus}
                    />
                    <tbody>
                      <>

                        {sortedInventoryData?.length ? sortedInventoryData.map((result, key) => {
                          return (
                            <tr key={key} className="">
                              <td className="zone-add-inventory__check-cell">
                                <div className="com-check">
                                  <input
                                    key={key}
                                    className="inventorytablecheck inventorytableHead gisClassTh zone_addinventory"
                                    id={result?.id}
                                    data-id={result?.id}
                                    value={result?.id}
                                    type="checkbox"
                                    onChange={(e) => handleChange(e)}
                                  />
                                  <label
                                    htmlFor={result?.id}
                                    className="com-check-label"
                                  />
                                </div>
                              </td>
                              <td className="zone-add-inventory__index-cell">
                                <span className="zone-add-inventory__index-num">
                                  {key + 1}
                                </span>
                              </td>
                              <td className="zone-add-inventory__ai-cell">
                                {result?.is_ai_suggestion ? (
                                  <span
                                    className="zone-add-inventory__ai-badge"
                                    title={t('Suggestion product')}
                                    aria-label={t('Suggestion product')}
                                  >
                                    <img
                                      src={aibirdeyeIcon}
                                      alt=""
                                      className="zone-add-inventory__ai-icon"
                                    />
                                    <span className="zone-add-inventory__ai-tooltip">
                                      {t('Suggestion product')}
                                    </span>
                                  </span>
                                ) : null}
                              </td>
                              <td className="table-pro-img" >
                                <img
                                  src={getProductImageSrc(result?.main_image)}
                                  alt={result?.SKU || String(key + 1)}
                                  onError={handleProductImageError}
                                />
                              </td>
                              <td className="">
                                {result?.SKU ? result?.SKU : "-"}
                              </td>
                              <td>
                                <div className="tooltip-area-up">{result?.Item_name ? result?.Item_name : "-"}</div>
                              </td>
                              <td>
                                <div className="tooltip-area-up">{result?.Size_name ? result?.Size_name : "-"}</div>
                              </td>
                              <td>
                                <div className={`tooltip-area-up ${result?.pos_Qty > 0 ? 'stockactive cursor-pointer' : ""}`}>{result?.stock_id ? result?.stock_id : "-"} {result?.pos_Qty > 0 ? <LinkAttachmentIcon /> : null} </div>
                              </td>
                              <td className="">{result?.po_QTY ? result?.po_QTY : "-"}</td>

                              <td className=''>
                                {
                                  result?.status_type === "stock" ?
                                    <div className="status-dot light-blue-bg  tooltip-area-up"><span className='tooltip-area-up-text'>{t("Stock")}</span></div> :
                                    result?.status_type === "transit" ?
                                      <div className="status-dot green-bg  tooltip-area-up"><span className='tooltip-area-up-text'>{t("Transit")}</span></div> :
                                      result?.status_type === "warehouse" ?
                                        <div className="status-dot status-gray-bg tooltip-area-up"><span className='tooltip-area-up-text'>{t("Warehouse")}</span></div> :
                                        result?.status_type === "reserve" ?
                                          <div className="status-dot yellow-bg tooltip-area-up"><span className='tooltip-area-up-text'>{t("Reserve")}</span></div> :
                                          result?.status_type === "repair_order" ?
                                            <div className="status-dot purple-bg tooltip-area-up"><span className='tooltip-area-up-text'>{t("Repair Order")}</span></div> :
                                            <div className="status-dot danger-bg tooltip-area-up"><span className='tooltip-area-up-text'>{t("Custom Order")}</span></div>
                                }
                              </td>





                            </tr>
                          );
                        }) : ''}
                      </>
                    </tbody>
                  </table>
                  {datalodaer ? (
                    <div className="zone-add-inventory__table-loader" aria-live="polite" aria-busy="true">
                      <TableLoader />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='zone_module-inner-bottom'>
                <div>
                  {t("Showing")} {total > 0 ? ((currentPage * limit) - limit + 1) : 0} {t("to")} {currentPage * limit <= total ? currentPage * limit : total} {t("of")} {total} {t("Entries")}
                </div>
                {inventoryData.length > 0 ? (
                  <Pagination
                    total={totalPages}
                    current={currentPage}
                    pagination={(crPage) => handlePaginations(crPage)}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className='zone_module-inner-back' onClick={() => navigate(-1)}>
                {t("Back")}
              </div>
            </div>
          </div>
        </div>
      </div>
      {toggleFilter &&
        <ZoneFilter
          setToggleFilter={setToggleFilter}
          setFilterItemData={setFilterItemData}
          filterItemData={filterItemData}
          filterData={filterOptionsData}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
        />
      }
    </>
  )
}
